import React, { useState } from 'react'
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup';
import axios from 'axios';
import LeftLogo from '../../../components/LeftLogo';
import PTInput from '../../../components/GenericComponents/PTInput';
import PTButton from '../../../components/GenericComponents/PTButton';
import { VS_SIGNUP_API } from '../../../constants/APIs';
import { handleError, handleSuccess } from '../../../utils/utility/snackbar';
import { startLoading, stopLoading } from '../../../utils/utility/loader';
import { FORM_FIELDS } from '../../../vc/constants';

export default function Signup() {
  const [loginError, setLoginError] = useState('')
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      fullName: '',
      companyName: '',
      companyEmail: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      fullName: Yup.string()
        .required(FORM_FIELDS.required),
      companyName: Yup.string(),
      // .required(FORM_FIELDS.required)
      companyEmail: Yup.string()
        .email(FORM_FIELDS?.emailValidFormat)
        .required(FORM_FIELDS.required),
      password: Yup.string()
        .required(FORM_FIELDS.required)
        .min(6, FORM_FIELDS.sizeLimit.tooShortPassword)
        .matches(FORM_FIELDS.passwordRegex, FORM_FIELDS.sizeLimit.passwordContain),
      confirmPassword: Yup.string()
        .required(FORM_FIELDS.required)
        .oneOf([Yup.ref('password'), null], "Password don't match"),
    }),
    onSubmit: (values, { resetForm }) => {
      userRegister({
        name: values.fullName.trim(),
        email: values.companyEmail,
        companyName: values.companyName.trim() || undefined,
        password: values.password
      }, resetForm)
    }
  });

  const userRegister = (userData, resetForm) => {
    startLoading();
    axios.post(VS_SIGNUP_API, userData)
      .then(res => {
        resetForm({ values: '' });
        handleSuccess(res)
        stopLoading();
        navigate('/venture-scout/thanksforinterest');
      })
      .catch((error) => {
        handleError(error)
        setLoginError(error?.response?.data?.message)
        stopLoading();
      })
  }

  return (
    <div>
      <div className="w-screen flex proptech-layout-wrapper flex-wrap">
        <div className="w-full md:w-3/5">
          <LeftLogo />
        </div>
        <div className="md:min-h-screen w-full md:w-2/5 items-center inline-flex justify-center relative">
          <form onSubmit={formik.handleSubmit}>
            <div className="wrapper-container">
              <div className="text-wrapper">
                <h2>{FORM_FIELDS.signUp}</h2>
                <p>{FORM_FIELDS.securitySeriously}</p>
              </div>
              {loginError ?
                <div className="danger-login">
                  <span>
                    {loginError}
                  </span>
                </div>
                : null
              }
              <div className='form-wrapper'>
                <div className={"form-group " + (formik.touched.fullName && formik.errors.fullName ? "error-parent" : "") + (!formik.errors.fullName && formik.values.fullName ? "success-attempt" : "")}>
                  <PTInput id="fullName" name="fullName" label='Full name' placeholder='Full name' className='form-control' handleOnChangeEvent={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.fullName} />
                  {formik.touched.fullName && formik.errors.fullName && <span className="error-txt">{formik.errors.fullName}</span>}
                </div>
                <div className={"form-group " + (formik.touched.companyName && formik.errors.companyName ? "error-parent" : "") + (!formik.errors.companyName && formik.values.companyName ? "success-attempt" : "")}>
                  <PTInput id="companyName" name="companyName" label='Company name (Optional)' placeholder='Company name (Optional)' className='form-control' handleOnChangeEvent={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.companyName} />
                  {formik.touched.companyName && formik.errors.companyName && <span className="error-txt">{formik.errors.companyName}</span>}
                </div>
                <div className={"form-group " + (formik.touched.companyEmail && formik.errors.companyEmail ? "error-parent" : "") + (!formik.errors.companyEmail && formik.values.companyEmail ? "success-attempt" : "")}>
                  <PTInput id="companyEmail" name="companyEmail" label='Company email' placeholder='Company email' className='form-control' handleOnChangeEvent={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.companyEmail} />
                  {formik.touched.companyEmail && formik.errors.companyEmail && <span className="error-txt">{formik.errors.companyEmail}</span>}
                </div>
                <div className={"form-group " + (formik.touched.password && formik.errors.password ? "error-parent" : "") + (!formik.errors.password && formik.values.password ? "success-attempt" : "")}>
                  <PTInput id="password" name="password" label='Password' placeholder='Password' className='form-control' type='password' handleOnChangeEvent={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.password} />
                  {formik.touched.password && formik.errors.password && <span className="error-txt">{formik.errors.password}</span>}
                </div>
                <div className="password-requirement">
                  <p>{FORM_FIELDS.mustContain}</p>
                  <ul>
                    <li>{FORM_FIELDS.upperCase}</li>
                    <li>{FORM_FIELDS.number}</li>
                    <li>{FORM_FIELDS.special}</li>
                  </ul>
                </div>
                <div className={"form-group " + (formik.touched.confirmPassword && formik.errors.confirmPassword ? "error-parent" : "") + (!formik.errors.confirmPassword && formik.values.confirmPassword ? "success-attempt" : "")}>
                  <PTInput id="confirmPassword" name="confirmPassword" label='Confirm password' placeholder='Confirm password' className='form-control' type='password' handleOnChangeEvent={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.confirmPassword} />
                  {formik.touched.confirmPassword && formik.errors.confirmPassword && <span className="error-txt">{formik.errors.confirmPassword}</span>}
                </div>
              </div>
              <PTButton label={'Sign up'} type="submit" className="normal-case fill-orange btn" />
              <div>
                <div className="not-have-account">
                  <span>{FORM_FIELDS.alreadyAccount}
                    {/* <NavLink to='/signup'> */}
                    <span className='font-bold text-[#111D43] cursor-pointer' onClick={() => window.location.href = '/venture-scout/login'}>
                      &nbsp; {FORM_FIELDS.logIn}
                    </span>
                    {/* </NavLink> */}
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
